<template>
    <SideModal 
        ref="sideModal"
        :sides="navs"
        @fechou="handleFechou"
    >
        <!-- Slot para exibir detalhes da ação -->
        <template #detalhes>
            <div class="side-body">
                <div class="row">
                    <div class="col-xs-12">
                        <p><strong>Status:</strong> {{ detalhesData.status }}</p>
                        <p><strong>Responsável:</strong> {{ detalhesData.nome_responsavel }}</p>

                        <p><strong>Previsão de Início:</strong> {{ detalhesData.data_estimada_inicio || 'Não definido' }}</p>
                        <p v-if="detalhesData.data_inicio"><strong>Início:</strong> {{ detalhesData.data_inicio }}</p>

                        <p><strong>Previsão de Conclusão:</strong> {{ detalhesData.data_estimada_conclusao || 'Não definida' }}</p>
                        <p v-if="detalhesData.data_conclusao"><strong>Conclusão:</strong> {{ detalhesData.data_conclusao }}</p>

                        <p v-if="detalhesData.justificativa_criacao">
                            <strong>Justificativa de Criação:</strong> {{ detalhesData.justificativa_criacao }}
                        </p>
                        <p v-if="detalhesData.justificativa_rejeicao">
                            <strong>Justificativa de Cancelamento:</strong> {{ detalhesData.justificativa_rejeicao }}
                        </p>
                    </div>
                    <div v-if="detalhesData.compromisso" class="col-xs-12">
                        <h4>Compromisso Relacionado</h4>
                        <p><strong>Descrição:</strong> {{ detalhesData.compromisso && detalhesData.compromisso.descritivo }}</p>
                        <p><strong>Período:</strong> {{ detalhesData.compromisso && detalhesData.compromisso.periodo }}</p>
                        <p><strong>Status:</strong> {{ detalhesData.compromisso && detalhesData.compromisso.status }}</p>
                    </div>
                    <div class="col-xs-12 slide-footer">
                        <button class="btn btn-default" @click="$emit('fechaModal', 'detalhes')">Fechar</button>
                    </div>
                </div>
            </div>
        </template>

        <!-- Slot para concluir a ação -->
        <template #concluir>
            <div class="side-body">
                <div class="row">
                    <div class="col-xs-12">
                        <p><strong>Status Atual:</strong> {{ concluirData.status }}</p>
                        <p><strong>Responsável:</strong> {{ concluirData.nome_responsavel }}</p>
                        <p><strong>Início:</strong> {{ concluirData.data_inicio || 'Não definido' }}</p>
                        <p><strong>Previsão de Conclusão:</strong> {{ concluirData.data_estimada_conclusao || 'Não definida' }}</p>
                        <span v-if="diferencaConclusao" class="diferenca" :class="diferencaConclusao.classe">
                            {{ diferencaConclusao.texto }}
                            <template v-if="diferencaConclusao.dias !== 0">
                                ({{ diferencaConclusao.dias }} {{ diferencaConclusao.dias === 1 ? 'dia' : 'dias' }})
                            </template>
                        </span>
                    </div>
                    <div class="col-xs-12">
                        <h4>Definir Concluir a ação?</h4>
                        <p><strong>Data de Conclusão:</strong> {{ dataAtualConclusao }}</p>
                    </div>
                    <div class="col-xs-12 slide-footer">
                        <button class="btn btn-success" @click="$emit('concluir', concluirData.id)">Concluir</button>
                        <button class="btn btn-default" @click="$emit('fechaModal', 'concluir')">Cancelar</button>
                    </div>
                </div>
            </div>
        </template>


        <template #iniciar>
            <div class="side-body">
                <div class="row">
                    <div class="col-xs-12">
                        <p><strong>Status Atual:</strong> {{ iniciarData.status }}</p>
                        <p><strong>Responsável:</strong> {{ iniciarData.nome_responsavel }}</p>
                        <p><strong>Previsão de Início:</strong> {{ iniciarData.data_estimada_inicio || 'Não definido' }}</p>
                        <span v-if="diferencaInicio" class="diferenca" :class="diferencaInicio.classe">
                            {{ diferencaInicio.texto }}
                            <template v-if="diferencaInicio.dias !== 0">
                                ({{ diferencaInicio.dias }} {{ diferencaInicio.dias === 1 ? 'dia' : 'dias' }})
                            </template>
                        </span>
                    </div>
                    <div class="col-xs-12">
                        <h4>Deseja Iniciar a ação?</h4>
                        <p><strong>Data de Início:</strong> {{ dataAtualInicio }}</p>
                    </div>
                    <div class="col-xs-12 slide-footer">
                        <button class="btn btn-success" @click="$emit('iniciar', iniciarData.id)">Iniciar</button>
                        <button class="btn btn-default" @click="$emit('fechaModal', 'iniciar')">Cancelar</button>
                    </div>
                </div>
            </div>
        </template>

        <template #editar>
            <div class="side-body">
                <div class="col-xs-12">
                    <p><strong>Compromisso:</strong> {{ editarData.compromisso && editarData.compromisso.descritivo }}</p>
                    <p><strong>Ação:</strong> {{ editarData.descritivo }}</p>

                    <div class="form-group">
                        <label class="control-label custom-font">Data de inicio estimada</label>
                        <datepicker v-model="editarData.data_estimada_inicio" />
                    </div>

                    <div class="form-group">
                        <label class="control-label custom-font">Data de conclusão estimada</label>
                        <datepicker v-model="editarData.data_estimada_conclusao" />
                    </div>
                </div>

                <div class="col-xs-12 slide-footer">
                    <button 
                        class="btn btn-success"
                        :disabled="!editarData.data_estimada_inicio || !editarData.data_estimada_conclusao"
                        @click="$emit('salvarEdicao', editarData)"
                    >
                        Salvar
                    </button>

                    <button class="btn btn-default" @click="$emit('fechaModal', 'editar')">Cancelar</button>
                </div>
            </div>
        </template>

        <template #aceitar>
            <div class="side-body">
                <div class="row">
                    <div class="col-xs-12">
                        <p><strong>Compromisso:</strong> {{ aceitarData.compromisso && aceitarData.compromisso.descritivo }}</p>
                        <p><strong>Unidade Executora:</strong> {{ aceitarData.compromisso && aceitarData.compromisso.nome_unidade_executora }}</p>
                        <p><strong>Ação:</strong> {{ aceitarData.descritivo }}</p>

                        <div class="form-group">
                            <label class="control-label custom-font">Data de início estimada</label>
                            <datepicker v-model="aceitarData.data_estimada_inicio" />
                        </div>

                        <div class="form-group">
                            <label class="control-label custom-font">Data de conclusão estimada</label>
                            <datepicker v-model="aceitarData.data_estimada_conclusao" />
                        </div>
                    </div>

                    <div class="col-xs-12 slide-footer">
                        <button 
                            class="btn btn-success"
                            :disabled="!aceitarData.data_estimada_inicio || !aceitarData.data_estimada_conclusao"
                            @click="$emit('aceitarAcao', aceitarData)"
                        >
                            Aceitar
                        </button>

                        <button class="btn btn-default" @click="$emit('fechaModal', 'aceitar')">Cancelar</button>
                    </div>
                </div>
            </div>
        </template>

        <template #cancelar>
            <div class="side-body">
                <div class="row">
                    <div class="col-xs-12">
                        <h4 class="modal-title">
                            Justifique {{ cancelarData.unidade === cancelarData.unidade_executora ? 'o Cancelamento' : 'a Rejeição' }}
                        </h4>
                        <p><strong>Compromisso:</strong> {{ cancelarData.compromisso && cancelarData.compromisso.descritivo }}</p>
                        <p><strong>Unidade Executora:</strong> {{ cancelarData.compromisso && cancelarData.compromisso.nome_unidade_executora }}</p>
                        <p><strong>Ação:</strong> {{ cancelarData.descritivo }}</p>

                        <textarea
                            v-model="justificativa"
                            class="form-control"
                            rows="5"
                            placeholder="Digite sua justificativa aqui..."
                        />
                    </div>

                    <div class="col-xs-12 slide-footer">
                        <button 
                            class="btn btn-success"
                            :disabled="!justificativa.trim()"
                            @click="$emit('cancelarAcao', { acao: cancelarData, justificativa: justificativa })"
                        >
                            Salvar
                        </button>

                        <button class="btn btn-default" @click="$emit('fechaModal', 'cancelar')">Cancelar</button>
                    </div>
                </div>
            </div>
        </template>

        <template #deletar>
        <div class="side-body">
            <div class="row">
                <div class="col-xs-12">
                    <p><strong>Ação a ser excluída:</strong></p>
                    <p><em>{{ deletarData.descritivo }}</em></p>
                </div>

                <div class="col-xs-12 slide-footer">
                    <button class="btn btn-danger" @click="$emit('deletar', deletarData.id)">
                        <font-awesome-icon icon="trash-alt" /> Excluir
                    </button>
                    <button class="btn btn-default" @click="$emit('fechaModal', 'deletar')">
                        Cancelar
                    </button>
                </div>
            </div>
        </div>
    </template>
    </SideModal>
</template>

<script>
import { SideModal } from '../common'
import datepicker from '@/components/common/Datepicker'

export default {
    name: 'SideAcao',
    components: { SideModal, datepicker },
    props: {
        navs: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            justificativa: '',
            dataAtualInicio: null,
            dataAtualConclusao: null,
        }
    },
    computed: {
        detalhesData() {
            const detalhesNav = this.navs.find(n => n.identidade === 'detalhes')
            return (detalhesNav && detalhesNav.data) ? detalhesNav.data : {}
        },
        concluirData() {
            const concluirNav = this.navs.find(n => n.identidade === 'concluir')
            return (concluirNav && concluirNav.data) ? concluirNav.data : {}
        },
        iniciarData() {
            const iniciarNav = this.navs.find(n => n.identidade === 'iniciar')
            return (iniciarNav && iniciarNav.data) ? iniciarNav.data : {}
        },
        editarData() {
            const editarNav = this.navs.find(n => n.identidade === 'editar')
            return (editarNav && editarNav.data) ? editarNav.data : {}
        },
        aceitarData() {
            const aceitarNav = this.navs.find(n => n.identidade === 'aceitar')
            return (aceitarNav && aceitarNav.data) ? aceitarNav.data : {}
        },
        cancelarData() {
            const cancelarNav = this.navs.find(n => n.identidade === 'cancelar')
            return (cancelarNav && cancelarNav.data) ? cancelarNav.data : {}
        },
        deletarData() {
            const deletarNav = this.navs.find(n => n.identidade === 'deletar')
            return (deletarNav && deletarNav.data) ? deletarNav.data : {}
        },
        diferencaInicio() {
            return this.calcularDiferenca(this.iniciarData.data_estimada_inicio)
        },
        diferencaConclusao() {
            return this.calcularDiferenca(this.concluirData.data_estimada_conclusao)
        }
    },
    methods: {
        abreModal(nome) {
            this.$refs.sideModal.abreModal(nome)
        },
        fechaModal(nome) {
            this.$refs.sideModal.fechaModal(nome)
        },
        handleFechou({ identidade }) {
            const nav = this.navs.find(n => n.identidade === identidade)
            if (nav) {
                nav.aberto = false
            }
        },
        calcularDiferenca(dataPrevistaStr) {
            if (!dataPrevistaStr) return null;

            const partes = dataPrevistaStr.split('/');
            const dataFormatadaISO = `${partes[2]}-${partes[1]}-${partes[0]}`;
            const dataPrevista = new Date(dataFormatadaISO + 'T00:00:00');
            const hoje = new Date();
            hoje.setHours(0, 0, 0, 0);

            const diffEmMS = hoje.getTime() - dataPrevista.getTime();
            const diffEmDias = Math.round(diffEmMS / (1000 * 60 * 60 * 24));

            if (diffEmDias === 0) {
                return { texto: 'Em dia', dias: 0, classe: 'status-ok' };
            } else if (diffEmDias > 0) {
                return { texto: 'Atrasado', dias: diffEmDias, classe: 'status-atrasado' };
            } else {
                return { texto: 'Adiantado', dias: Math.abs(diffEmDias), classe: 'status-adiantado' };
            }
        }
    },
    watch: {
        iniciarData: {
            handler(novosDados) {
                if (novosDados && novosDados.id) {
                    this.dataAtualInicio = new Date().toLocaleDateString('pt-BR');
                } else {
                    this.dataAtualInicio = null;
                }
            },
            deep: true
        },
        concluirData: {
            handler(novosDados) {
                if (novosDados && novosDados.id) {
                    this.dataAtualConclusao = new Date().toLocaleDateString('pt-BR');
                } else {
                    this.dataAtualConclusao = null;
                }
            },
            deep: true
        },
        'cancelarData.id'(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.justificativa = ''
            }
        },
    }
}
</script>

<style scoped>
.side-body {
    padding: 20px;
    font-size: 1.6rem;
}

.side-body p {
    margin-bottom: 12px;
}

.slide-footer {
    margin-top: 20px;
    display: flex;
    gap: 10px;
    justify-content: flex-end;
}

h3,
h4 {
    margin-top: 24px;
}

.diferenca {
    font-weight: bold;
    padding: 3px 8px;
    border-radius: 4px;
    color: #fff;
    font-size: 1.4rem;
}

.status-adiantado {
    background-color: #5cb85c;
}

.status-ok {
    background-color: #337ab7;
}

.status-atrasado {
    background-color: #d9534f;
}
</style>


// WEBPACK FOOTER //
// src/components/planogoverno/SideAcao.vue